import React from "react"
import { LinkLayout } from "../../../../../../Shared/Frontend/utils/links"
import { ParsedOverviewDetailItem } from "../widgets/overviewWidget.state"
import i18next from "i18next"
import { SharedBlockLayout } from "../../../modernBlocks/blocks/shared/sharedBlock.layout"
import { getContentTypeTitle } from "./searchPage.api"

export const SearchPageLayout = {
  SearchHeader: (props: { children?: React.ReactNode; }): JSX.Element => {
    const { children } = props
    return (
      <div className="searchform ls-container ls-gutter">
        <div className="searchform__inner">
          {children}
        </div>
      </div>
    )
  },
  PageHeader: (): JSX.Element => {
    return (
      <header className='pageheader ph ph--text'>
        <div className="ph__inner ls-container--l">
          <div className='ph__content'>
            <div className='ph__content-inner'>
              <h1 className='ph__title title--l'><span>{i18next.t('Search:Title')}</span></h1>
            </div>
          </div>

          <div className="ph__visual">
            <div className='ph__visual-inner fit-picture'>
              <svg className="ph__mask" height="241" viewBox="0 0 47 241" width="47" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path clipRule="evenodd" d="m0 0v241l46.8611-241z" fillRule="evenodd"/></svg>
            </div>
          </div>
        </div>
      </header>
    )
  },
  Wrap:  (props: { count: number, searchTerm: string, children?: React.ReactNode; }): JSX.Element => {
    const { count, searchTerm, children } = props

    return (
      <section className="block block--search">
        <div className="ls-container ls-gutter ls-spacing">
          {searchTerm != '' && <SearchPageLayout.Header count={count} />}

          <div className="block__content">{children}</div>
        </div>
      </section>
    )
  },
  Empty: (props:{ searchTerm: string }): JSX.Element => {
    return (
      <div className="page__empty">
        <p className="text--s">
          {props.searchTerm != '' ? i18next.t('Search:NoResults') : i18next.t('Search:FillSearch')}
        </p>
      </div>
    )
  },
  Header: (props: {count: number}): JSX.Element => {
    const { count } = props

    return (
      <header className="block__header">
        <h2 className="block__title title--m">{count} {count == 1 ? i18next.t('Search:ResultsTitleSingular') : i18next.t('Search:ResultsTitlePlural')}</h2>
      </header>
    )
  }
}

export function renderSearchItems(items: Immutable.List<ParsedOverviewDetailItem>/* , suggestions: Suggestion[] */): JSX.Element {
  return (
    <div className="block__teasers teasers">
      <ul className="teasers__list">
        {items.map((item, index) => {
          return (
            <li className="teasers__item" key={`ts-${index}`}>
              <article className="teaser teaser--search">
                <LinkLayout
                  link={{
                    url: item.Link ? item.Link.url : '',
                    title: item.Link ? item.Link.title : item.Title,
                    target: '_self',
                    kind: 'link'
                  }}
                  className="teaser__link"
                >
                  <div className="teaser__inner">
                    <div className="teaser__content">
                    <p className="teaser__meta">{getContentTypeTitle(item.Kind)}</p>
                      <h2 className="teaser__title title--xs"><span>{item.Title}</span></h2>
                      <p className='teaser__intro text--s'>{item.Description}</p>
                    </div>

                    <div className="teaser__visual">
                      {item.image &&
                        <SharedBlockLayout.ModernImageSrcSet
                          image={item.image}
                          lazyload={true}
                          priority={undefined}
                          classNames="teaser__image"
                          imageProportions={{
                            width: '185',
                            height: '124',
                            sizes: '(min-width: 768px) 185px, 30vw'
                          }}
                        />
                      }
                    </div>
                  </div>
                </LinkLayout>
              </article>
            </li>
          )
        })}
      </ul>
    </div>
  )
}